import { get } from 'core/libs/lodash';
import deepmerge from 'core/libs/deepmerge';

import loadScript from './load-script';

import { CAPIRS_SRC } from 'core/site/constants';

let promise;

function resolveSdk(resolve) {
  const {
    Adf,
    Begun,
  } = window;

  resolve({ Adf, Begun });
}

export default function initAds() {
  if (promise) return promise;

  if (process.env.NODE_RUNTIME && process.env.NODE_ENV !== 'test') {
    return Promise.reject(new Error('Unavailable on SSR'));
  }

  promise = new Promise((resolve, reject) => {
    /**
     * Если используется серверный рендеринг рекламы, то нужные API уже будет
     * доступны в глобальном скоупе.
     *
     * В таком случае резолвим промис используя их без подключиния sdk.
     */
    if (window.Adf && window.Begun) {
      resolveSdk(resolve);
    } else {
      /**
       * Важно! Если кто-то уже ожидает загрузки, то не перезатираем
       * эти обработчики.
       */
      const prevHandler = get(window.begun_callbacks, 'lib.init');

      /**
       * Если sdk еще не доступен, то подписываемся на его инициализацию
       * и ждем загрузки.
       */
      window.begun_callbacks = deepmerge(window.begun_callbacks || {}, {
        lib: {
          init(...args) {
            if (prevHandler) prevHandler.apply(this, args);
            resolveSdk(resolve);
          },
        },
      });

      /**
       * Если на странице уже есть `capirs_async.js`, то просто ждем загрузки
       * не добавляя новый скрипт.
       *
       * Рекламные технологии сказали, что двух скриптов на странице быть
       * не должно ¯\_(ツ)_/¯
       */
      if (!document.querySelector('[src$="capirs_async.js"]')) {
        loadScript(CAPIRS_SRC).catch(reject);
      }
    }
  }).catch(console.error);

  return promise;
}
